/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EditUserDto { 
    /**
     * Id autenticazione esterna
     */
    authId: string;
    /**
     * Nome
     */
    firstname: string;
    /**
     * Cognome
     */
    lastname: string;
    /**
     * Email
     */
    email: string;
    /**
     * Telefono
     */
    phone: string;
    /**
     * Ruoli
     */
    role: EditUserDto.RoleEnum;
    /**
     * Aziende
     */
    companies: Array<string>;
}
export namespace EditUserDto {
    export const RoleEnum = {
        Hr: 'HR',
        Admin: 'ADMIN',
        Technician: 'TECHNICIAN'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


